var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDinersClub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.118 19.7333H13.5794C18.9827 19.7333 23.2884 15.4466 23.4572 10.1513V10.0672C23.3728 4.68785 18.9827 0.317103 13.5794 0.401156H9.69586C4.54589 0.569261 0.493466 4.94001 0.662317 10.1513C0.662317 15.3626 4.8836 19.6492 10.118 19.7333ZM2.35083 10.0672C2.35083 5.69644 5.98113 2.08217 10.3713 2.08217C14.7614 2.08217 18.3917 5.69644 18.3917 10.0672C18.3917 14.4379 14.7614 18.0522 10.3713 18.0522C5.98113 18.0522 2.35083 14.4379 2.35083 10.0672ZM11.6377 15.4466V4.77187C14.5925 5.52835 16.4499 8.47019 15.6901 11.412C15.1835 13.4293 13.6639 14.9423 11.6377 15.4466ZM5.13688 8.72235C4.37705 11.6642 6.14998 14.6901 9.10488 15.4466V4.77187C7.16309 5.27619 5.64343 6.78914 5.13688 8.72235Z",
    fill: "#0079BE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDinersClub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DinersClub.c25580ec67de6d1b6e7759803459eda3.svg";